import loadable from '@loadable/component';

import type { RouteType } from '../utils';

export default (path: string): RouteType[] => [
  {
    name: 'legacyHandler',
    path: `${path}`,
    component: loadable(() => import('../components/LegacyRoutes')),
    exact: false,
    requiredRoles: [],
    requiredFeatures: [],
  },
  {
    name: 'notFound',
    path: `${path}`,
    component: loadable(() => import('../components/NotFound')),
    exact: false,
    requiredRoles: [],
    requiredFeatures: [],
  },
];
